import React, { Component } from 'react';
import { arrayOf, func, number, oneOfType, shape, string } from 'prop-types';
import SettingsSection from './SettingsSection/SettingsSection';
import './SalaryRangeSettings.scss';

class SalaryRangeSettings extends Component {
  static propTypes = {
    getPercentOfTotal: func,
    marketElements: arrayOf(
      shape({
        field_title: string,
        source_field: string
      })
    ),
    maxElementDisplay: string,
    maxPct: oneOfType([number, string]),
    maxValue: number,
    midElementDisplay: string,
    midPct: number,
    midValue: oneOfType([number, string]),
    minElementDisplay: string,
    minPct: number,
    minValue: oneOfType([number, string]),
    roundTo: number,
    setElementValue: func,
    setProposedRangeValue: func,
    setTempProposedRangeValue: func,
    setRangePctValue: func,
    tempMaxValue: string,
    tempMinValue: string,
    tempMidValue: string
  };

  render() {
    const {
      getPercentOfTotal,
      marketElements,
      maxElementDisplay,
      maxPct,
      maxValue,
      midElementDisplay,
      midPct,
      midValue,
      minElementDisplay,
      minPct,
      minValue,
      roundTo,
      setElementValue,
      setRangePctValue,
      setProposedRangeValue,
      setTempProposedRangeValue,
      tempMaxValue,
      tempMinValue,
      tempMidValue
    } = this.props;
    const isMinDisabled = minElementDisplay ? !this.props.findProposedRangeValue(minElementDisplay) : true;
    const isMidDisabled = midElementDisplay ? !this.props.findProposedRangeValue(midElementDisplay) : true;
    const isMaxDisabled = maxElementDisplay ? !this.props.findProposedRangeValue(maxElementDisplay) : true;

    return (
      <div className="modify__range-settings">
        <SettingsSection
          displayValue={minElementDisplay}
          marketElements={marketElements}
          percent={minPct}
          rangeInputValue={getPercentOfTotal(minPct, minValue)}
          roundTo={roundTo}
          section="min"
          setElementValue={setElementValue}
          setProposedRangeValue={setProposedRangeValue}
          setTempProposedRangeValue={setTempProposedRangeValue}
          setRangePctValue={setRangePctValue}
          tempValue={tempMinValue}
          isDisabled={isMinDisabled}
        />
        <SettingsSection
          displayValue={midElementDisplay}
          marketElements={marketElements}
          percent={midPct}
          rangeInputValue={isMidDisabled ? midValue : tempMidValue ? tempMidValue : getPercentOfTotal(midPct, midValue)}
          roundTo={roundTo}
          section="mid"
          setElementValue={setElementValue}
          setProposedRangeValue={setProposedRangeValue}
          setTempProposedRangeValue={setTempProposedRangeValue}
          setRangePctValue={setRangePctValue}
          tempValue={tempMidValue}
          isDisabled={isMidDisabled}
        />
        <SettingsSection
          displayValue={maxElementDisplay}
          marketElements={marketElements}
          percent={maxPct}
          rangeInputValue={isMaxDisabled ? maxValue : tempMaxValue ? tempMaxValue : getPercentOfTotal(maxPct, maxValue)}
          roundTo={roundTo}
          section="max"
          setElementValue={setElementValue}
          setProposedRangeValue={setProposedRangeValue}
          setTempProposedRangeValue={setTempProposedRangeValue}
          setRangePctValue={setRangePctValue}
          tempValue={tempMaxValue}
          isDisabled={isMaxDisabled}
        />
      </div>
    );
  }
}

export default SalaryRangeSettings;
